export const columnFields = [
	'id',
	'name',
	'takeoffTypeRef',
	'organizationId',
	'measurementTypeRef',
	'ingredients',
	'ingredientCount',

	'createdAt',
	'updatedAt',
] as const;
